import {Routes} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard').then(c => c.Dashboard),
    canActivate: [MsalGuard]
  },
  {
    path: 'car-access',
    loadComponent: () => import('./car-access/car-access').then(c => c.CarAccess),
    canActivate: [MsalGuard]
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  }
];
